import React, { useState, useCallback, useRef, useEffect } from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
//import Carousel, { Pagination } from 'react-native-snap-carousel';
import { FontAwesome } from "@expo/vector-icons";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused } from "@react-navigation/native";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import ScreenLoader from "../../components/ScreenLoader";
import { toast } from "../../utils/toast";
import { If, Then, Else } from "react-if";
import styles from "./styles";
import api from "../../services/api";
import GoBackButton from "../../components/GoBackButton";

const BankAccount = ({ navigation }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef(null);
  const isFocused = useIsFocused();

  useEffect(() => {
    getDataAccounts();
  }, [isFocused]);

  async function getDataAccounts() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .get("/bank-accounts", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        var accounts = [];

        res.data.data.map((item) => {
          accounts.push({
            bank: item.bank.bank,
            bankId: item.bank.id,
            typeAccount: item.bank_account_type.name,
            typeAccountId: item.bank_account_type_id,
            agency: item.branch,
            account: item.account,
            id: item.id,
          });
        });

        setCards(accounts);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        const intl = useIntl();
        toast(
          intl.formatMessage({ id: "bankAccount.erroCarregaDados" }),
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  const renderItem = useCallback(({ item, index }) => {
    return (
      <View style={styles.contentCard}>
        <TouchableOpacity
          style={styles.contentEdit}
          onPress={() => navigation.navigate("EditBankAccount", { item })}
        >
          <FontAwesome name="edit" size={24} color="#000" />
        </TouchableOpacity>

        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccount.banco" />{" "}
          <Text style={styles.textDescription}>{item.bank}</Text>
        </Text>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccount.tipoConta" />{" "}
          <Text style={styles.textDescription}>{item.typeAccount}</Text>
        </Text>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccount.agencia" />{" "}
          <Text style={styles.textDescription}>{item.agency}</Text>
        </Text>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccount.conta" />{" "}
          <Text style={styles.textDescription}>{item.account}</Text>
        </Text>
      </View>
    );
  }, []);

  return (
    <>
      <ScreenLoader loading={isLoading} />
      <HeaderTabs
        title={<FormattedMessage id="bankAccount.contaBancaria" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="bankAccount.gerencieSuasContas" />
          </Text>
        }
      />
      <GoBackButton />
      <View style={styles.container}>
        <If condition={cards.length != 0}>
          <Then>
            <View style={styles.cardsContainer}>
              {cards.map((item, index) => (
                <View style={styles.contentCard} key={index}>
                  <TouchableOpacity
                    style={styles.contentEdit}
                    onPress={() =>
                      navigation.navigate("EditBankAccount", { item })
                    }
                  >
                    <FontAwesome name="edit" size={24} color="#077A97" />
                  </TouchableOpacity>

                  <View style={styles.viewInfo}>
                    <Text
                      style={{
                        ...styles.textDescription,
                        fontWeight: "bold",
                        color: "#077A97",
                        textAlign: "center",
                      }}
                    >
                      {item.bank}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-evenly",
                    }}
                  >
                    <Text style={styles.textInfo}>
                      <FormattedMessage id="bankAccount.agencia" />
                      <Text style={styles.textDescription}>{item.agency}</Text>
                    </Text>

                    <Text style={styles.textInfo}>
                      <FormattedMessage id="bankAccount.conta" />
                      <Text style={styles.textDescription}>{item.account}</Text>
                    </Text>
                  </View>

                  <View style={{ alignSelf: "center" }}>
                    <Text style={styles.textInfo}>
                      <FormattedMessage id="bankAccount.tipoConta" />
                      <Text style={styles.textDescription}>
                        {item.typeAccount}
                      </Text>
                    </Text>
                  </View>
                </View>
              ))}
            </View>
          </Then>
          <Else>
            <View>
              <Text style={styles.textNotFoundAccounts}>
                <FormattedMessage id="bankAccount.erroNehumaConta" />
              </Text>
            </View>
          </Else>
        </If>
        <TouchableOpacity
          style={styles.btnAdd}
          onPress={() => navigation.navigate("NewBankAccount")}
        >
          <Image
            style={styles.addIcon}
            source={require("../../../assets/add_icon.svg")}
          />
          <Text style={styles.textBtn}>
            <FormattedMessage id="bankAccount.adicionarConta" />
          </Text>
        </TouchableOpacity>
      </View>
    </>
  );
};

export default BankAccount;
